import { reportDepositsTypes } from './types';
import { newDate } from "helpers/dateTools";

const { SET_REPORT_DEPOSITS_FILTERS, RESTORE_INITIAL } = reportDepositsTypes;

const initialState = {
  ReportDeposits: [],
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportDepositsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_REPORT_DEPOSITS_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value
      }
    case RESTORE_INITIAL:
      return initialState

    default:
      return state;
  }
};